import { object, string } from "yup"

export const registerFormInitial = {
    first_name : "",
    last_name : "",
    email :""
}

export const registerFormSchema = object().shape({
    first_name : string().required("Register.firstName"),
    last_name : string().required("Register.lastName"),
    email : string().email("Register.email").optional()
})